import { BannerSponsor } from './banner-sponsor';

export class Event {

    public id: string;
    public name: string;

    public context_id: string;
    public key: string = '';
    public master: boolean;
    public belongsToProduct: boolean;
    
    public congress: boolean = false;
    public annuity: boolean = false;

    public location: string;
    public location_id: string;
    
    public text: string;        
	//public team: any[] = [];
    public materials: any[] = [];
    public active: boolean = true;


    public limit: number;  // não está em uso!

    public limit_per_member: number;
    public control_ticket_by_topic: boolean = false; // se s vagas são controladas por evento ou tópico

    public deleted: boolean = false;

    public docUsers: string; 
    public docUserTop: number;       
    public docUserLeft: number;       

    public docStaff: string;     
    public docStaffTop: number;       
    public docStaffLeft: number;       

    public startDay: Date;

    public sponsors: any[] = [];
    
    public urlQRCodeUser: string = "";
    public urlQRCodeStaff: string = "";

    public image_web: string = "";
    public image_mobile: string = "";

  //  public sponsor_id: string;
  //  public sponsor_name: string;
  //  public banner: string;
    

    constructor() {}
}

export class Day {

    public id: string;
    public event_id: string;
    //public congress: boolean;
    public date: Date;
    public name: string;
    public text: string = "";    
   // public team: any[] = [];
    public materials: any[] = [];
    public deleted: boolean = false;

    constructor() {}
}

export class Activity {

    public id: string;    
    public event_id: string;
    public day_id: string;
    public date: Date;
    public location: string;
    public location_id: string;
    public name: string;
    public text: string;    
	  public startTime: string;
	  public duration: number;
    //public team: any[] = [];
    public materials: any[] = [];
    public deleted: boolean = false;
    
    public sponsors: any[] = [];

    public depto: string;
    public depto_id: string;


    constructor() {}
}

export class Topic {

    public id: string;
    public event_id: string;
    public day_id: string;
    public activity_id: string;       
    public date: Date;
    public name: string;
    public text: string;    
	public startTime: string;
	public duration: number;
//	public team: any[] = [];
    public materials: any[] = [];

    public sponsor_id: string;
    public sponsor_name: string;
    public banner: string;

    public text1: string;
    public text2: string;
    public text3: string;

    public deleted: boolean = false;
   
    constructor() {}
}

